import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../../utils/axios";

const initialState = {
    invitation: {
        maxInvitationLimit: 30
    },
    platformPricing: {}
}

const adminSettingsSlice = createSlice({
    name: 'adminSettings',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getPlatformPricing.fulfilled, (state, action) => {
                state.platformPricing = action.payload.data || {};
            })
    }
});

export const { } = adminSettingsSlice.actions;

export default adminSettingsSlice.reducer;


/**
 * @async
 * @function getAdminSettings
 * @description Fetches the admin settings from the backend API.
 * @returns {Promise<Object>} The response data from the API or an error object.
 * @throws Will throw an error if the API request fails.
 * 
 * @example
 * dispatch(getPlatformPricing())
 */
export const getPlatformPricing = createAsyncThunk(
    'adminSettings/getPlatformPricing',
    async (_, { rejectWithValue }) => {
        try {
            const backendResponse = await axios.get("/api/v2/settings/get_settings");

            const response = {
                ...backendResponse?.data,
                code: backendResponse?.status
            }

            return response;
        } catch (error) {
            return rejectWithValue({
                ...error?.data,
                code: error?.status
            });
        }
    }
);